import { render, staticRenderFns } from "./RefundManagementScreen.vue?vue&type=template&id=719fa5c8&scoped=true&"
import script from "./RefundManagementScreen.vue?vue&type=script&lang=js&"
export * from "./RefundManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719fa5c8",
  null
  
)

export default component.exports